import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Utils from "../../utils";
import { useTranslation } from "react-i18next";
import Image1 from "../../asset/images/illustration-img.png";
import ConfigDB from "../../config";

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const record = Utils.getRecordForCurrentPath(location);
  const { t } = useTranslation();
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const today = new Date();
  const options = { weekday: "long", month: "long", day: "numeric" };
  const dateStr = today.toLocaleDateString(undefined, options);
  const timeStr = today.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
  const [migrateStep, setMigrateStep] = useState(0);
  const [expoDismissed, setExpoDismissed] = useState(
    () => localStorage.getItem("tp_expo2026_dismissed") === "1"
  );

  const dismissExpo = () => {
    localStorage.setItem("tp_expo2026_dismissed", "1");
    setExpoDismissed(true);
  };

  // useEffect(() => {
  //   const hasSeenWizard = localStorage.getItem("hasSeenMigrateWizard");

  //   if (!hasSeenWizard) {
  //     setMigrateStep(1);
  //   }
  // }, []);

  const handleSkip = () => {
    // localStorage.setItem("hasSeenMigrateWizard", "true");
    setMigrateStep(2);
  };

  const handleMigrate = () => {
    // localStorage.setItem("hasSeenMigrateWizard", "false");
    setMigrateStep(2);
    navigate("/wizard-migrate")

  };

  return (
    <>
      {record && record[0]?.display_name === "View" && (
        <div>
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>

                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid container-custom-height-new">
              <div className="row">
                <div className="col-md-12">
                  <div>
                    <div
                      className="card shadow-sm border-0 text-white"
                      style={{
                        backgroundColor: "#81bb42",
                        borderRadius: "15px",
                      }}
                    >
                      <div className="row g-0 align-items-center">
                        <div className="col-md-8 p-4">
                          <p className="mb-1 small">
                            {dateStr} • {timeStr}
                          </p>
                          <h4 className="fw-bold">
                            {t("goodDay")}, {companyId?.name || "User"}! 🚗
                          </h4>
                          <p className="mb-0">{t("ManageVehicle")}</p>
                        </div>

                        <div className="col-md-4 text-center">
                          <img
                            src={Image1}
                            alt="Vehicle illustration"
                            style={{ maxWidth: "120px" }}
                            className="img-fluid vehicle-animate"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {!expoDismissed && (
                  <div className="col-md-12 mt-3">
                    <div className="tp-dash-expo">
                      <button
                        type="button"
                        className="tp-dash-expo-close"
                        onClick={dismissExpo}
                        aria-label={t("dashboard_expo_dismiss")}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                      <div className="tp-dash-expo-glow" aria-hidden="true"></div>
                      <div className="tp-dash-expo-content">
                        <span className="tp-dash-expo-tag">
                          <span className="tp-dash-expo-dot"></span>
                          {t("dashboard_expo_tag")}
                        </span>
                        <h3 className="tp-dash-expo-title">
                          {t("dashboard_expo_title")}
                        </h3>
                        <p className="tp-dash-expo-subtitle">
                          {t("dashboard_expo_subtitle")}
                        </p>
                        <div className="tp-dash-expo-meta">
                          <span>
                            <i className="bi bi-geo-alt-fill"></i>{" "}
                            {t("dashboard_expo_location")}
                          </span>
                          <span>
                            <i className="bi bi-calendar-event-fill"></i>{" "}
                            {t("dashboard_expo_date")}
                          </span>
                        </div>
                        <div className="tp-dash-expo-actions">
                          <a
                            href="https://pt.telepecas.com/expomecanica2026"
                            target="_blank"
                            rel="noreferrer"
                            className="tp-dash-expo-btn"
                          >
                            {t("dashboard_expo_cta")}{" "}
                            <i className="bi bi-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                      <div className="tp-dash-expo-visual" aria-hidden="true">
                        <div className="tp-dash-expo-badge">
                          <div className="tp-dash-expo-badge-year">2026</div>
                          <div className="tp-dash-expo-badge-label">
                            EXPOMECÂNICA
                          </div>
                          <div className="tp-dash-expo-badge-stand">
                            Stand 5D01
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {migrateStep === 1 && (
                  <div
                    className="card fuelCard text-center p-3"
                    style={{ border: "none" }}
                  >
                    <div className="card-header bg-transparent border-0">
                      <h5 className="card-title fw-bold m-0">
                        {t("wizardMigrate")}
                      </h5>
                    </div>

                    <div className="card-body">
                      <p className="fs-6 text-muted mb-4">{t("DoMigrate")}</p>

                      <img
                        src={Image1}
                        alt="Vehicle illustration"
                        className="img-fluid vehicle-animate mb-3"
                        style={{ maxWidth: "120px" }}
                      />

                      <div className="d-flex justify-content-center mt-3">

                        <button
                          type="button"
                          className="btn btn-outline-secondary me-2 px-4"
                          onClick={handleSkip}
                        >
                          {t("skip")} <i className="bi bi-x-lg ms-1"></i>
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary px-4"
                          onClick={handleMigrate}
                        >
                          {t("yes")}, {t("migrate")}{" "}
                          <i className="bi bi-check-lg ms-1"></i>
                        </button>

                     
                      </div>
                    </div>
                  </div>
               )} 
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default Dashboard;
